export default [
  {
    path: 'home',
    label: 'Home',
  },
  {
    path: 'feature',
    label: 'Features',
  },
  {
    path: 'testimonial',
    label: 'Twitter',
  },
  {
    path: 'pricing',
    label: 'Quiz',
  },
];
